import React, { forwardRef, useId } from 'react';
import { ChevronDown } from 'lucide-react';
import Field, { inputClass, describedBy } from './Field';

const SelectInput = forwardRef(({
  label,
  hint,
  error,
  required,
  optionalLabel,
  className,
  id: idProp,
  name,
  options = [],
  placeholder = 'Select',
  ...rest
}, ref) => {
  const generatedId = useId();
  const id = idProp || `${name || 'select'}-${generatedId}`;

  return (
    <Field id={id} label={label} hint={hint} error={error} required={required} optionalLabel={optionalLabel} className={className}>
      <div className="relative">
        <select
          ref={ref}
          id={id}
          name={name}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={describedBy(id, { hint, error })}
          aria-required={required || undefined}
          className={inputClass(Boolean(error), 'appearance-none pr-10')}
          {...rest}
        >
          {placeholder !== null && <option value="">{placeholder}</option>}
          {options.map((option) => (
            <option key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden="true" />
      </div>
    </Field>
  );
});

SelectInput.displayName = 'SelectInput';

export default SelectInput;
